import React from 'react';
import '../template-file-css/document-file-template.css';


export const GHP_NursingFollowUpTemplate = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_NursingFollowUpTemplate' className='file-pdf-document'>
            <div className='file-template'>

                <h2> LIVING ARRANGEMENTS</h2>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Number  in Household</span>
                            <input type="text" id="txtNumberHousehold" name="txtNumberHousehold" className="add-only" />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Designated Caregiver:</span>
                            <input type="text" id="txtDesignatedCaregiver" name="txtDesignatedCaregiver" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Home Conditions:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHomeConditions_1" name="cbHomeConditions_1" className='add-only' value="HomeConditions_1" />Clean
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHomeConditions_2" name="cbHomeConditions_2" className='add-only' value="HomeConditions_2" />Unclean
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Safety </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSafety_1" name="cbSafety_1" className='add-only' value="Safety_1" />Good
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSafety_2" name="cbSafety_2" className='add-only' value="Safety_2" />Fair
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSafety_3" name="cbSafety_3" className='add-only' value="Safety_3" />Poor
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Hygiene:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHygiene_1" name="cbHygiene_1" className='add-only' value="Hygiene_1" />Good
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHygiene_2" name="cbHygiene_2" className='add-only' value="Hygiene_2" />Fair
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHygiene_3" name="cbHygiene_3" className='add-only' value="Hygiene_3" />Poor
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_1' name='txtComments_1' className='add-only'></textarea>
                </p>
                <h3>VITALS</h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Temp:</span>
                            <input type="text" id="txtTemp" name="txtTemp" className="add-only" />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Pulse</span>
                            <input type="text" id="txtPulse" name="txtPulse" className="add-only" />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Blood Pressure</span>
                            <input type="text" id="txtBloodPressure" name="txtBloodPressure" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Respiration:</span>
                            <input type="text" id="txtRespiration" name="txtRespiration" className="add-only" />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Height</span>
                            <input type="text" id="txtHeight" name="txtHeight" className="add-only" />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Weight</span>
                            <input type="text" id="txtWeight" name="txtWeight" className="add-only" />
                        </td>
                    </tr>
                </table>
                <h3>ALLERGIES</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Medications:</span>
                            <input type="text" id="txtMedications" name="txtMedications" className="add-only" />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Food:</span>
                            <input type="text" id="txtFood" name="txtFood" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Pollens</span>
                            <input type="text" id="txtPollens" name="txtPollens" className="add-only" />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Other:</span>
                            <input type="text" id="txtOther" name="txtOther" className="add-only" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_2' name='txtComments_2' className='add-only'></textarea>
                </p>

                <h3>MEDICATIONS</h3>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>MEDICATION</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>DOSAGE</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>FREQENCY</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>DATE OF RX</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>PHYSICAN</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="MEDICATION_1" name="MEDICATION_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDOSAGE_1" name="txtDOSAGE_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFREQENCY_1" name="txtFREQENCY_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="dtDateOfRx_1" name="dtDateOfRx_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtPHYSICAN_1" name="txtPHYSICAN_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="MEDICATION_2" name="MEDICATION_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDOSAGE_2" name="txtDOSAGE_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFREQENCY_2" name="txtFREQENCY_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="dtDateOfRx_2" name="dtDateOfRx_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtPHYSICAN_2" name="txtPHYSICAN_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="MEDICATION_3" name="MEDICATION_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDOSAGE_3" name="txtDOSAGE_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFREQENCY_3" name="txtFREQENCY_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="dtDateOfRx_3" name="dtDateOfRx_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtPHYSICAN_3" name="txtPHYSICAN_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="MEDICATION_4" name="MEDICATION_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDOSAGE_4" name="txtDOSAGE_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFREQENCY_4" name="txtFREQENCY_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="dtDateOfRx_4" name="dtDateOfRx_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtPHYSICAN_4" name="txtPHYSICAN_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="MEDICATION_5" name="MEDICATION_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDOSAGE_5" name="txtDOSAGE_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFREQENCY_5" name="txtFREQENCY_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="dtDateOfRx_5" name="dtDateOfRx_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtPHYSICAN_5" name="txtPHYSICAN_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="MEDICATION_6" name="MEDICATION_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDOSAGE_6" name="txtDOSAGE_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFREQENCY_6" name="txtFREQENCY_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="dtDateOfRx_6" name="dtDateOfRx_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtPHYSICAN_6" name="txtPHYSICAN_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Has there been any recent changes in medications?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbchangesinmedications_Yes' name='rbchangesinmedications' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbchangesinmedications_No' name='rbchangesinmedications' className='add-only' value='No' /> No &nbsp;
                        </td>
                    </tr>
                </table>

                <p className='w-750'><strong>If yes, </strong></p>
                <p className='w-750'>
                    <span className='eleHeader'>explain:</span>
                    <textarea id="txtexplain_1" name="txtexplain_1" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Is client compliant with medications?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbclientcompliant_Yes' name='rbclientcompliant' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbclientcompliant_No' name='rbclientcompliant' className='add-only' value='No' /> No &nbsp;
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>explain:</span>
                    <textarea id="txtexplain_2" name="txtexplain_2" className='add-only'></textarea>

                    <span className='eleHeader'>Efficacy of Current Medications  (Does current medications produce desired effect)</span>
                    <textarea id="txtexptxtCurrentMedicationslain_2" name="txtCurrentMedications" className='add-only'></textarea>

                    <span className='eleHeader'>Previous Medications Used and reason(s) for discharge off of previous medications:</span>
                    <textarea id="txtPreviousMedications" name="txtPreviousMedications" className='add-only'></textarea>
                </p>

                <h3>PHYSICAL</h3>

                <table>
                    <tr>
                        <td className='w-650'>
                            <span className='eleHeader'>SKIN:</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Jaundice</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbSkinNutritiousHistory_1_Yes" name="rbSkinNrbSkinNutritiousHistory_1" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbSkinmedicalHistory_1_No" name="rbSkinNrbSkinNutritiousHistory_1" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Rash</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbSkinNutritiousHistory_2_Yes" name="rbSkinNutritiousHistory_2" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbSkinNutritiousHistory_2_No" name="rbSkinNutritiousHistory_2" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Open Wounds</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbSkinNutritiousHistory_3_Yes" name="rbSkinNutritiousHistory_3" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbSkinNutritiousHistory_3_No" name="rbSkinNutritiousHistory_3" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Incision/Scars</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbSkinNutritiousHistory_4_Yes" name="rbSkinNutritiousHistory_4" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbSkinNutritiousHistory_4_No" name="rbSkinNutritiousHistory_4" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Itching</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbSkinNutritiousHistory_5_Yes" name="rbSkinNutritiousHistory_5" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbSkinNutritiousHistory_5_No" name="rbSkinNutritiousHistory_5" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Tattoos</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbSkinNutritiousHistory_6_Yes" name="rbSkinNutritiousHistory_6" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbSkinNutritiousHistory_6_No" name="rbSkinNutritiousHistory_6" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Edema</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbSkinNutritiousHistory_7_Yes" name="rbSkinNutritiousHistory_7" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbSkinNutritiousHistory_7_No" name="rbSkinNutritiousHistory_7" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Bruises</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbSkinNutritiousHistory_8_Yes" name="rbSkinNutritiousHistory_8" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbSkinNutritiousHistory_8_No" name="rbSkinNutritiousHistory_8" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Hydrated</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbSkinNutritiousHistory_9_Yes" name="rbSkinNutritiousHistory_9" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbSkinNutritiousHistory_9_No" name="rbSkinNutritiousHistory_9" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Piercing</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbSkinNutritiousHistory_10_Yes" name="rbSkinNutritiousHistory_10" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbSkinNutritiousHistory_10_No" name="rbSkinNutritiousHistory_10" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Observe any additional marks on ADM</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbSkinNutritiousHistory_11_Yes" name="rbSkinNutritiousHistory_11" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbSkinNutritiousHistory_11_No" name="rbSkinNutritiousHistory_11" className='add-only' value="0" />
                            </td></center>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_3' name='txtComments_3' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-650'>
                            <span className='eleHeader'>EYES:</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Contacts:</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbEyesNutritiousHistory_1_Yes" name="rbEyesNutritiousHistory_1" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbEyesNutritiousHistory_1_No" name="rbEyesNutritiousHistory_1" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Glasses:</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbEyesNutritiousHistory_2_Yes" name="rbEyesNutritiousHistory_2" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbEyesNutritiousHistory_2_No" name="rbEyesNutritiousHistory_2" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Blurred Vision:</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbEyesNutritiousHistory_3_Yes" name="rbEyesNutritiousHistory_3" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbEyesNutritiousHistory_3_No" name="rbEyesNutritiousHistory_3" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Redness:</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbEyesNutritiousHistory_4_Yes" name="rbEyesNutritiousHistory_4" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbEyesNutritiousHistory_4_No" name="rbEyesNutritiousHistory_4" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Inflammation:</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbEyesNutritiousHistory_5_Yes" name="rbEyesNutritiousHistory_5" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbEyesNutritiousHistory_5_No" name="rbEyesNutritiousHistory_5" className='add-only' value="0" />
                            </td></center>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_4' name='txtComments_4' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-550'>
                            <span className='eleHeader'>EARS:</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Right</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Left</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            <strong>Hearing Difficulty</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbEearNutritiousHistory_1_Yes" name="rbEearNutritiousHistory_1" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbEearNutritiousHistory_1_No" name="rbEearNutritiousHistory_1" className='add-only' value="0" />
                            </td>
                            <td className='w-50'>
                                <input type="checkbox" id="cbEarRight_1" name="cbEarRight_1" className='add-only' value="EarRight_1" />
                            </td>
                            <td className='w-50'>
                                <input type="checkbox" id="cbEarLeft_1" name="cbEarLeft_1" className='add-only' value="EarLeft_1" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            <strong>Hearing Aid</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbEearNutritiousHistory_2_Yes" name="rbEearNutritiousHistory_2" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbEearNutritiousHistory_2_No" name="rbEearNutritiousHistory_2" className='add-only' value="0" />
                            </td>
                            <td className='w-50'>
                                <input type="checkbox" id="cbEarRight_2" name="cbEarRight_2" className='add-only' value="EarRight_2" />
                            </td>
                            <td className='w-50'>
                                <input type="checkbox" id="cbEarLeft_2" name="cbEarLeft_2" className='add-only' value="EarLeft_2" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            <strong>Earaches</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbEearNutritiousHistory_3_Yes" name="rbEearNutritiousHistory_3" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbEearNutritiousHistory_3_No" name="rbEearNutritiousHistory_3" className='add-only' value="0" />
                            </td>
                            <td className='w-50'>
                                <input type="checkbox" id="cbEarRight_3" name="cbEarRight_3" className='add-only' value="EarRight_1" />
                            </td>
                            <td className='w-50'>
                                <input type="checkbox" id="cbEarLeft_3" name="cbEarLeft_3" className='add-only' value="EarLeft_1" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            <strong>Dizziness</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbEearNutritiousHistory_4_Yes" name="rbEearNutritiousHistory_4" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbEearNutritiousHistory_4_No" name="rbEearNutritiousHistory_4" className='add-only' value="0" />
                            </td>
                            <td className='w-50'>
                                <input type="checkbox" id="cbEarRight_4" name="cbEarRight_4" className='add-only' value="EarRight_4" />
                            </td>
                            <td className='w-50'>
                                <input type="checkbox" id="cbEarLeft_4" name="cbEarLeft_4" className='add-only' value="EarLeft_4" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            <strong>Ringing</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbEearNutritiousHistory_5_Yes" name="rbEearNutritiousHistory_5" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbEearNutritiousHistory_5_No" name="rbEearNutritiousHistory_5" className='add-only' value="0" />
                            </td>
                            <td className='w-50'>
                                <input type="checkbox" id="cbEarRight_5" name="cbEarRight_5" className='add-only' value="EarRight_5" />
                            </td>
                            <td className='w-50'>
                                <input type="checkbox" id="cbEarLeft_5" name="cbEarLeft_5" className='add-only' value="EarLeft_5" />
                            </td></center>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_5' name='txtComments_5' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-650'>
                            <span className='eleHeader'>NOSE AND THROAT:</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Sinus Congestion</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNoseThroatNutritiousHistory_1_Yes" name="rbNoseThroatNutritiousHistory_1" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNoseThroatNutritiousHistory_1_No" name="rbNoseThroatNutritiousHistory_1" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Nose Bleeds</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNoseThroatNutritiousHistory_2_Yes" name="rbNoseThroatNutritiousHistory_2" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNoseThroatNutritiousHistory_2_No" name="rbNoseThroatNutritiousHistory_2" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Sore Throat</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNoseThroatNutritiousHistory_3_Yes" name="rbNoseThroatNutritiousHistory_3" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNoseThroatNutritiousHistory_3_No" name="rbNoseThroatNutritiousHistory_3" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Difficulty Swallowing</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNoseThroatNutritiousHistory_4_Yes" name="rbNoseThroatNutritiousHistory_4" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNoseThroatNutritiousHistory_4_No" name="rbNoseThroatNutritiousHistory_4" className='add-only' value="0" />
                            </td></center>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_6' name='txtComments_6' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-650'>
                            <span className='eleHeader'>REPRODUCTIVE:</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Penile Discharge</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbReproductiveNutritiousHistory_1_Yes" name="rbReproductiveNutritiousHistory_1" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbReproductiveNutritiousHistory_1_No" name="rbReproductiveNutritiousHistory_1" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Penile Pain/Tenderness</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbReproductiveNutritiousHistory_2_Yes" name="rbReproductiveNutritiousHistory_2" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbReproductiveNutritiousHistory_2_No" name="rbReproductiveNutritiousHistory_2" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Scrotal Pain/Swelling</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbReproductiveNutritiousHistory_3_Yes" name="rbReproductiveNutritiousHistory_3" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbReproductiveNutritiousHistory_3_No" name="rbReproductiveNutritiousHistory_3" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>LMP</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbReproductiveNutritiousHistory_4_Yes" name="rbReproductiveNutritiousHistory_4" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbReproductiveNutritiousHistory_4_No" name="rbReproductiveNutritiousHistory_4" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Breast Problems</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbReproductiveNutritiousHistory_5_Yes" name="rbReproductiveNutritiousHistory_5" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbReproductiveNutritiousHistory_5_No" name="rbReproductiveNutritiousHistory_5" className='add-only' value="0" />
                            </td></center>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_7' name='txtComments_7' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-650'>
                            <span className='eleHeader'>MOUTH:</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Retainers</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbMouthNutritiousHistory_1_Yes" name="rbMouthNutritiousHistory_1" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbMouthNutritiousHistory_1_No" name="rbMouthNutritiousHistory_1" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Bloody Gums</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbMouthNutritiousHistory_2_Yes" name="rbMouthNutritiousHistory_2" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbMouthNutritiousHistory_2_No" name="rbMouthNutritiousHistory_2" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Toothache</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbMouthNutritiousHistory_3_Yes" name="rbMouthNutritiousHistory_3" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbMouthNutritiousHistory_3_No" name="rbMouthNutritiousHistory_3" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Braces</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbMouthNutritiousHistory_4_Yes" name="rbMouthNutritiousHistory_4" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbMouthNutritiousHistory_4_No" name="rbMouthNutritiousHistory_4" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Cavities</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbMouthNutritiousHistory_5_Yes" name="rbMouthNutritiousHistory_5" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbMouthNutritiousHistory_5_No" name="rbMouthNutritiousHistory_5" className='add-only' value="0" />
                            </td></center>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_8' name='txtComments_8' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-650'>
                            <span className='eleHeader'>RESPIRATORY</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Wheezing</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbRespiratoryNutritiousHistory_1_Yes" name="rbRespiratoryNutritiousHistory_1" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbRespiratoryNutritiousHistory_1_No" name="rbRespiratoryNutritiousHistory_1" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Dyspnea</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbRespiratoryNutritiousHistory_2_Yes" name="rbRespiratoryNutritiousHistory_2" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbRespiratoryNutritiousHistory_2_No" name="rbRespiratoryNutritiousHistory_2" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Hemoptysis</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbRespiratoryNutritiousHistory_3_Yes" name="rbRespiratoryNutritiousHistory_3" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbRespiratoryNutritiousHistory_3_No" name="rbRespiratoryNutritiousHistory_3" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Cough</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbRespiratoryNutritiousHistory_4_Yes" name="rbRespiratoryNutritiousHistory_4" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbRespiratoryNutritiousHistory_4_No" name="rbRespiratoryNutritiousHistory_4" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Asthma</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbRespiratoryNutritiousHistory_5_Yes" name="rbRespiratoryNutritiousHistory_5" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbRespiratoryNutritiousHistory_5_No" name="rbRespiratoryNutritiousHistory_5" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Smoker</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbRespiratoryNutritiousHistory_6_Yes" name="rbRespiratoryNutritiousHistory_6" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbRespiratoryNutritiousHistory_6_No" name="rbRespiratoryNutritiousHistory_6" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Other</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbRespiratoryNutritiousHistory_7_Yes" name="rbRespiratoryNutritiousHistory_7" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbRespiratoryNutritiousHistory_7_No" name="rbRespiratoryNutritiousHistory_7" className='add-only' value="0" />
                            </td></center>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_9' name='txtComments_9' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-650'>
                            <span className='eleHeader'>CARDIOVASCULAR</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>High Blood Pressure</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbCardiovascularNutritiousHistory_1_Yes" name="rbCardiovascularNutritiousHistory_1" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbCardiovascularNutritiousHistory_1_No" name="rbCardiovascularNutritiousHistory_1" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Chest Pain</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbCardiovascularNutritiousHistory_2_Yes" name="rbCardiovascularNutritiousHistory_2" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbCardiovascularNutritiousHistory_2_No" name="rbCardiovascularNutritiousHistory_2" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Palpitations</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbCardiovascularNutritiousHistory_3_Yes" name="rbCardiovascularNutritiousHistory_3" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbCardiovascularNutritiousHistory_3_No" name="rbCardiovascularNutritiousHistory_3" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Cardiac Surgery</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbCardiovascularNutritiousHistory_4_Yes" name="rbCardiovascularNutritiousHistory_4" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbCardiovascularNutritiousHistory_4_No" name="rbCardiovascularNutritiousHistory_4" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Other</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbCardiovascularNutritiousHistory_5_Yes" name="rbCardiovascularNutritiousHistory_5" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbCardiovascularNutritiousHistory_5_No" name="rbCardiovascularNutritiousHistory_5" className='add-only' value="0" />
                            </td></center>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_10' name='txtComments_10' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-650'>
                            <span className='eleHeader'>GI/GU</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Abdominal Pain</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbGiGuNutritiousHistory_1_Yes" name="rbGiGuNutritiousHistory_1" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbGiGuNutritiousHistory_1_No" name="rbGiGuNutritiousHistory_1" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Heartburn</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbGiGuNutritiousHistory_2_Yes" name="rbGiGuNutritiousHistory_2" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbGiGuNutritiousHistory_2_No" name="rbGiGuNutritiousHistory_2" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Constipation</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbGiGuNutritiousHistory_3_Yes" name="rbGiGuNutritiousHistory_3" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbGiGuNutritiousHistory_3_No" name="rbGiGuNutritiousHistory_3" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Diarrhea</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbGiGuNutritiousHistory_4_Yes" name="rbGiGuNutritiousHistory_4" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbGiGuNutritiousHistory_4_No" name="rbGiGuNutritiousHistory_4" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Blood in Stool</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbGiGuNutritiousHistory_5_Yes" name="rbGiGuNutritiousHistory_5" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbGiGuNutritiousHistory_5_No" name="rbGiGuNutritiousHistory_5" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Painful Urination</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbGiGuNutritiousHistory_6_Yes" name="rbGiGuNutritiousHistory_6" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbGiGuNutritiousHistory_6_No" name="rbGiGuNutritiousHistory_6" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Increase in Frequency</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbGiGuNutritiousHistory_7_Yes" name="rbGiGuNutritiousHistory_7" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbGiGuNutritiousHistory_7_No" name="rbGiGuNutritiousHistory_7" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Blood in Urine</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbGiGuNutritiousHistory_8_Yes" name="rbGiGuNutritiousHistory_8" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbGiGuNutritiousHistory_8_No" name="rbGiGuNutritiousHistory_8" className='add-only' value="0" />
                            </td></center>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_11' name='txtComments_11' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-650'>
                            <span className='eleHeader'>NEUROLOGICAL</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Headache</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNeurologicalNutritiousHistory_1_Yes" name="rbNeurologicalNutritiousHistory_1" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNeurologicalNutritiousHistory_1_No" name="rbNeurologicalNutritiousHistory_1" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Fainting</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNeurologicalNutritiousHistory_2_Yes" name="rbNeurologicalNutritiousHistory_2" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNeurologicalNutritiousHistory_2_No" name="rbNeurologicalNutritiousHistory_2" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Convulsions</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNeurologicalNutritiousHistory_3_Yes" name="rbNeurologicalNutritiousHistory_3" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNeurologicalNutritiousHistory_3_No" name="rbNeurologicalNutritiousHistory_3" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Insomnia</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNeurologicalNutritiousHistory_4_Yes" name="rbNeurologicalNutritiousHistory_4" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNeurologicalNutritiousHistory_4_No" name="rbNeurologicalNutritiousHistory_4" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Trembling</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNeurologicalNutritiousHistory_5_Yes" name="rbNeurologicalNutritiousHistory_5" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNeurologicalNutritiousHistory_5_No" name="rbNeurologicalNutritiousHistory_5" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Disoriented</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNeurologicalNutritiousHistory_6_Yes" name="rbNeurologicalNutritiousHistory_6" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNeurologicalNutritiousHistory_6_No" name="rbNeurologicalNutritiousHistory_6" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Drug Use:</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNeurologicalNutritiousHistory_7_Yes" name="rbNeurologicalNutritiousHistory_7" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNeurologicalNutritiousHistory_7_No" name="rbNeurologicalNutritiousHistory_7" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Type</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNeurologicalNutritiousHistory_8_Yes" name="rbNeurologicalNutritiousHistory_8" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNeurologicalNutritiousHistory_8_No" name="rbNeurologicalNutritiousHistory_8" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Alcohol Use</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNeurologicalNutritiousHistory_9_Yes" name="rbNeurologicalNutritiousHistory_9" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNeurologicalNutritiousHistory_9_No" name="rbNeurologicalNutritiousHistory_9" className='add-only' value="0" />
                            </td></center>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>Type</strong>
                        </td>
                        <center><td className='w-50'>
                            <input type="radio" id="rbNeurologicalNutritiousHistory_10_Yes" name="rbNeurologicalNutritiousHistory_10" className='add-only' value="1" />
                        </td>
                            <td className='w-50'>
                                <input type="radio" id="rbNeurologicalNutritiousHistory_10_No" name="rbNeurologicalNutritiousHistory_10" className='add-only' value="0" />
                            </td></center>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_12' name='txtComments_12' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>REFERRALS</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReferrals_1" name="cbReferrals_1" className='add-only' value="Referrals_1" /> Medical follow-up
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReferrals_2" name="cbReferrals_2" className='add-only' value="Referrals_2" /> Alcohol/Substance Abuse Education
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReferrals_3" name="cbReferrals_3" className='add-only' value="Referrals_3" /> Medication Education
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReferrals_4" name="cbReferrals_4" className='add-only' value="Referrals_4" /> Fitness and Nutrition Education
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReferrals_5" name="cbReferrals_5" className='add-only' value="Referrals_5" /> Health Education
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReferrals_6" name="cbReferrals_6" className='add-only' value="Referrals_6" /> HIV/AIDS Education
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReferrals_7" name="cbReferrals_7" className='add-only' value="Referrals_7" /> Sexual Education
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReferrals_8" name="cbReferrals_8" className='add-only' value="Referrals_8" /> HIV/AIDS Testing/Treatment Referral
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReferrals_9" name="cbReferrals_9" className='add-only' value="Referrals_9" /> Chronic Disease Education/Training
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReferrals_10" name="cbReferrals_10" className='add-only' value="Referrals_10" /> Referral to primary care physician
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="checkbox" id="cbReferrals_11" name="cbReferrals_11" className='add-only' value="Referrals_11" /> Other:
                    <textarea id="txtReferrals_11" name="txtReferrals_11" className='add-only'></textarea>

                    <span className='eleHeader'>SUMMARY</span>
                    <textarea id="txtSUMMARY" name="txtSUMMARY" className='add-only'></textarea>

                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Nurse Signature/Credentials </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='w-450'><h4>Wendy Wilkins, RN</h4></td>
                    </tr>
                    <tr>
                        <td className='w-450 signature'  >&nbsp;
                        </td>

                    </tr>
                    <tr>
                        <td className="small">Please Type/Print Name and Credential
                        </td>
                    </tr>
                </table>





            </div>
        </form>

    )
}